<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addLocationAndCountsDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item required prop="locationId" label="课程地点:">
          <el-select v-model="form.locationId" placeholder="选择课程地点">
            <el-option
              v-for="item in this.courseLocationList.courseLocationList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item required prop="max" label="学员上限:">
          <el-input
            type="number"
            placeholder="请输入学员上限(分钟)"
            v-model="form.max"
          ></el-input>
        </el-form-item>

        <el-form-item required prop="min" label="学员下限:">
          <el-input
            type="number"
            placeholder="请输入学员下限(分钟)"
            v-model="form.min"
          ></el-input>
        </el-form-item>

        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  editLocationAndCounts,
  addLocationAndCounts,
} from "@/api/locationAndCounts";

export default {
  name: "addFundDialogs",
  data() {
    return {
      isVisible: this.isShow,
      form: {
        id: "",
        locationId: "",
        max: "",
        min: "",
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    courseTypeList: Object,
    courseLocationList: Object,
  },
  computed: {
    ...mapGetters(["addLocationAndCountsDialog"]),
  },
  created() {},
  mounted() {
    if (this.addLocationAndCountsDialog.type === "edit") {
      this.form = this.dialogRow.param;
      console.log(this.form);
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData);
          console.log(para);
          // edit
          if (this.addLocationAndCountsDialog.type === "edit") {
            editLocationAndCounts(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.isVisible = false;
                this.$emit("getLocationAndCounts");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          } else {
            // add
            addLocationAndCounts(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getLocationAndCounts");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
